export default __webpack_public_path__ + "static/59376402_589107668245386_5461494668174957622_n-7e1309f1a112d0ca0d8211184189523c.jpg";